import { featureFlagsMap, useHasActiveFeatureFlag } from '@clatter/platform';

export interface CustomPageEntry {
  ID: number | string;
  url: string;
  DisplayName: string;
  // When true, the entry links out to `url` in a new tab instead of the
  // in-app `/custom-page/:ID` iframe view.
  external?: boolean;
}

// Optum landing page — surfaced among the custom pages behind the
// `ng-optum-landing-page` feature flag. Opens in a new browser tab.
export const OPTUM_CUSTOM_PAGE: CustomPageEntry = {
  ID: 'optum',
  url: 'https://www.optum.clatter.io/',
  DisplayName: 'Landing Page',
  external: true,
};

// Returns the backend-provided custom pages with the Optum landing page
// appended when the `ng-optum-landing-page` feature flag is active.
export const useCustomPagesWithOptum = (customPages: unknown): CustomPageEntry[] => {
  const optumEnabled = useHasActiveFeatureFlag(featureFlagsMap.NG.optumLandingPage);
  const base = Array.isArray(customPages) ? (customPages as CustomPageEntry[]) : [];
  return optumEnabled ? [OPTUM_CUSTOM_PAGE, ...base] : base;
};
